export enum ChatMessageType {
  chat = "chat",
  muc = "muc",
  recepit = "receipt",
  call = "call",
}
